import { jsx as o, jsxs as d, Fragment as y } from "react/jsx-runtime";
import { CheckIcon as p } from "../../../icons/check-icon.mjs";
import { FORM_ELEMENT_PADDING_CLASS_NAME as x } from "../../../constants/base-class-name.mjs";
import { twMerge as n, twJoin as f } from "tailwind-merge";
const w = ({
  item: r,
  optionClassName: c,
  optionIconWrapperClassName: s,
  optionRef: e,
  as: t
}) => {
  const b = (r == null ? void 0 : r.customCaption) ?? (r == null ? void 0 : r.caption), u = ({ disabled: a, selected: l }) => n(
    "bg-background-secondary text-text-primary",
    x,
    "border-b last:border-b-0 border-text-secondary/30",
    "group hover:bg-brand-primary hover:text-background-secondary",
    "data-[focus]:bg-brand-primary data-[focus]:text-background-secondary",
    "flex justify-between items-center gap-3 w-full break-all",
    l && "bg-brand-primary text-background-secondary",
    a && "bg-text-secondary hover:bg-text-secondary data-[focus]:bg-text-secondary text-background-secondary hover:text-background-secondary data-[focus]:text-background-secondary cursor-not-allowed",
    c,
    r == null ? void 0 : r.className
  ), g = ({ selected: a }) => /* @__PURE__ */ d(y, { children: [
    b,
    /* @__PURE__ */ d("div", { className: n("flex items-center gap-3", s), children: [
      a && /* @__PURE__ */ o(
        p,
        {
          className: f(
            "group-hover:stroke-background-secondary stroke-background-secondary h-4 w-4"
          ),
          "aria-hidden": "true"
        }
      ),
      r == null ? void 0 : r.additionalRender
    ] })
  ] });
  return /* @__PURE__ */ o(
    t,
    {
      disabled: r == null ? void 0 : r.disabled,
      ref: e,
      value: r,
      className: u,
      "data-test-id": r == null ? void 0 : r.dataTestAttribute,
      children: g
    },
    r == null ? void 0 : r.id
  );
};
export {
  w as renderOption
};
